import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    qrCodeSubjectList: [],
}
export const getQRCodeSubjectList = createAsyncThunk(
    'QRCode/getQRCodeSubjectList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("/qr-code/feasibility-listing", data);
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

export const getPatientDetailsById = createAsyncThunk(
    'QRCode/getPatientDetailsById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/qr-code/details/${id}`);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.message : error.message)
        }
    }
)

export const getPatientDetailsByIdNoAuth = createAsyncThunk(
    'QRCode/getPatientDetailsByIdNoAuth',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/qr-code/details/${id}/no-auth`);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.message : error.message)
        }
    }
)


export const generateQRCode = createAsyncThunk(
    'QRCode/generateQrCode',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/qr-code/generate', data);
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.respnse.message : error.message)
        }
    }
)

export const printForQR = createAsyncThunk(
    'QRCode/printForQR',
    async (data, { rejectWithValue }) => {
        const { id: _id, bags: numberOfBags } = data;
        try {
            const response = await api.post(`qr-code/print/${_id}`, { number_of_bags: numberOfBags })
            notify.success(response?.data ? response?.data?.message : "Success")
            return response.data
        } catch (error) {
            notify.error(error ?? error?.data?.message)
            return rejectWithValue(error.response ? error.response.message : error.message)
        }
    }
)

export const rePrintForQR = createAsyncThunk(
    'QRCode/printForQR',
    async (data, { rejectWithValue }) => {
        const { id: _id } = data;
        delete data.id
        try {
            const response = await api.post(`qr-code/reprint/${_id}`, data)
            notify.success(response?.data ? response?.data?.message : "Success")
            return response.data
        } catch (error) {
            notify.error(error ?? error?.data?.message)
            return rejectWithValue(error.response ? error.response.message : error.message)
        }
    }
)

const qrCodeSlice = createSlice({
    name: "QRCode",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getQRCodeSubjectList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getQRCodeSubjectList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.qrCodeSubjectList = action.payload.data
            })
            .addCase(getQRCodeSubjectList.rejected, (state) => {
                state.isLoading = false;
            })
        builder
            .addCase(getPatientDetailsById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPatientDetailsById.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(getPatientDetailsById.rejected, (state) => {
                state.isLoading = false;
            })
        builder
            .addCase(getPatientDetailsByIdNoAuth.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPatientDetailsByIdNoAuth.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(getPatientDetailsByIdNoAuth.rejected, (state) => {
                state.isLoading = false;
            })
    }
})

export const qrGenerationIsLoading = (state) => state.qrCode.isLoading;
export const subjectQRGeneration = (state) => state.qrCode.qrCodeSubjectList;
export default qrCodeSlice.reducer;